import { useEffect } from "react";
import { connect } from "react-redux";
import * as ColorHelper from "./helpers/ColorHelper";

const BrandApplicator = ({ enterprise, requesting }) => {
  useEffect(() => {
    if (!requesting) {
      const brandColor =
        (enterprise?.brandColor &&
          `#${enterprise?.brandColor.replace("#", "")}`) ||
        "#3b82f6";

      document.documentElement.style.setProperty(
        "--edexlms-primary-color",
        brandColor
      );
      document.documentElement.style.setProperty(
        "--edexlms-primary-hover-color",
        ColorHelper.generateShade("#3b82f6", "#2563eb", brandColor)
      );
      document.documentElement.style.setProperty(
        "--edexlms-primary-box-color",
        ColorHelper.generateShade("#3b82f6", "#bfdbfe", brandColor)
      );
      document.documentElement.style.setProperty(
        "--edexlms-primary-menu-color",
        `${brandColor}08`
      );
      document.documentElement.style.setProperty(
        "--edexlms-primary-highilight-color",
        `${brandColor}40`
      );

      document.title = enterprise?.name || "EdexLMS 2.0";
      const link = document.querySelector("link[rel~='icon']");
      link.href = enterprise?.logo
        ? `${new URL(enterprise.logo, process.env.REACT_APP_URL).toString()}`
        : "/favicon.ico";
    } else {
      const link = document.querySelector("link[rel~='icon']");
      link.href = "/favicon.ico";
      document.title = "Loading...";
    }
  }, [enterprise, requesting]);

  return null;
};

const mapStateToProps = (state) => ({
  enterprise: state?.global?.enterprise,
  requesting: state?.global?.requesting,
});

export default connect(mapStateToProps)(BrandApplicator);
